export class LandingPageModel {
  userid: number;
  title: string;
  description = '';
}
